import { render, staticRenderFns } from "./SharedFolderLayout.vue?vue&type=template&id=37cd6986&"
import script from "./SharedFolderLayout.vue?vue&type=script&lang=ts&"
export * from "./SharedFolderLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports